// Modified by Xappiens for Xappiens Secure. Based on Psono, Copyright Sascha Pfeiffer, Apache License 2.0.
import {
	SET_AUTO_APPROVE_PLAINTEXT_PASSWORD,
	SET_FINGERPRINT,
	SET_KNOWN_HOSTS,
	SET_REMOTE_CONFIG_JSON,
} from "../actions/action-types";

const defaultKnownHosts = [
	{
		url: "https://secure.xappiens.es/server",
		verify_key:
			"0648b809bf1d57480d4df97a8140274122f92901c9ea8cf4c4e78f2066821bf6",
	},
];

function persistent(
	state = {
		knownHosts: defaultKnownHosts,
		autoApproveLdap: {},
		remoteConfigWebClientUrl: null,
		remoteConfigJson: null,
		fingerprint: null,
	},
	action,
) {
	switch (action.type) {
		case SET_KNOWN_HOSTS:
			return Object.assign({}, state, {
				knownHosts: action.knownHosts,
			});
		case SET_AUTO_APPROVE_PLAINTEXT_PASSWORD:
			return Object.assign({}, state, {
				autoApproveLdap: action.autoApproveLdap,
			});
		case SET_REMOTE_CONFIG_JSON:
			return Object.assign({}, state, {
				remoteConfigWebClientUrl: action.remoteConfigWebClientUrl,
				remoteConfigJson: action.remoteConfigJson,
			});
		case SET_FINGERPRINT:
			return Object.assign({}, state, {
				fingerprint: action.fingerprint,
			});
		default:
			return state;
	}
}

export default persistent;
